export enum ProductType {
    product = 0,
    maintain = 1
}